export { CommonInteractionStyling } from './InputStyling';
